import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword, apiErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); if (busy) return; setBusy(true); setErr("");
    try { await forgotPassword(email.trim()); setSent(true); }
    catch (e) { setErr(apiErr(e?.response?.data?.detail)); setBusy(false); }
  };
  return (
    <div className="auth-screen" data-testid="forgot-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-agency">MAKE IT HAPPEN PHILLY</div>
        <h1 className="auth-title">Reset your password</h1>
        {sent ? (
          <p className="auth-sub" data-testid="forgot-sent">If an account exists for that email, a secure reset link has been sent. The link expires in 1 hour.</p>
        ) : (
          <>
            <p className="auth-sub">Enter your MIHP email and we'll send a secure reset link.</p>
            <label className="auth-lbl">Email
              <input className="auth-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </label>
            {err && <div className="auth-err">{err}</div>}
            <button className="auth-btn" type="submit" disabled={busy || !email} data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</button>
          </>
        )}
        <Link to="/login" className="auth-link" data-testid="forgot-back">Back to Sign In</Link>
      </form>
    </div>
  );
}
